<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import DynamicFilterBase from '@js/components/filter/dynamic-filter-base';

export default {
    extends: DynamicFilterBase,

    data() {
        let that = this;

        return {
            externalRemotes: {
                categories() {
                    return that.categorysRemote();
                },

                tag() {
                    return that.tagsRemote();
                },
            },
        };
    },

    computed: {
        ...mapState('override_pricebook', ['filters', 'searchMeta']),

        loading() {
            return this.onLoading('get-override-pricebook-meta');
        },
    },

    created() {
        this.getSearchOverrideMeta();
        this.getCategoriesListIfNecessary();
        this.getParentTagListIfNecessary();
    },

    methods: {
        ...mapActions('override_pricebook', ['getSearchOverrideMeta']),
        ...mapMutations('override_pricebook', ['setFilters']),
        ...mapActions('category', ['getCategoriesListIfNecessary']),
        ...mapActions('tag', ['getParentTagListIfNecessary']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/override_pricebook/override-filter.vue